// utils/cache.js
const cache = new Map();

export const getCachedData = async (key, fetchFn) => {
  if (cache.has(key)) {
    return cache.get(key);
  }
  const data = await fetchFn();
  cache.set(key, data);
  return data;
};

export const clearCache = () => cache.clear();